// components/ProtectedLayout.tsx
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/index.tsx";
import SideNav from "../SideNav/index.tsx";
//

const ProtectedLayout = () => {
 
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return (localStorage.getItem("sidebar:collapsed") || "true") === "true";
    } catch {
      return true;
    }
  });

  useEffect(() => {
    const handler = (e: any) => {
      if (e?.detail?.collapsed !== undefined) setCollapsed(!!e.detail.collapsed);
    };
    window.addEventListener("sidebar:toggle", handler);
    return () => window.removeEventListener("sidebar:toggle", handler);
  }, []);

  // Lock body scroll; main will handle scrolling
  useEffect(() => {
    document.body.classList.add("layout-locked");
    return () => {
      document.body.classList.remove("layout-locked");
    };
  }, []);

  return (
    <div className="page relative h-screen">
      <SideNav />
      <div
        className={[
          "relative z-10 h-full flex flex-col transition-all",
          collapsed ? "md:ml-20" : "md:ml-64",
        ].join(" ")}
      >
        <Header compact />
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default ProtectedLayout;
